export default {
  hello: '¡Hola!',
  back: 'Volver a la búsqueda',
  card: {
    label: 'Ver detalles de la actividad',
    infos: 'Información sobre la actividad',
    favorite: 'Añadir a favoritos',
    new: 'Nueva actividad',
    from: 'A partir de ',
  },
  list: {
    label: 'Lista de actividades',
    total: 'actividades encontradas',
    load: 'Ver más',
  },
  menu: {
    sorting: 'Ordenar por',
    filters: 'Filtros',
    relevance: 'Relevancia',
    price_asc: 'Precio (ascendente)',
    price_desc: 'Precio (descendente)',
    ranking: 'Evaluación / Puntuación',
    place: 'Lugar',
    moment: 'Momento del día',
    duration: 'Duración',
    price: 'Precio',
    min: 'Precio € mín.',
    max: 'Precio € máx.',
    range: 'Disponible ',
    day: 'durante el día',
    from: 'desde',
    to: 'hasta',
    start: 'Duración mín (h.):',
    end: 'Duración máx (h.):',
  },
  search: {
    label: 'Búsqueda de actividad',
    button: 'Buscar',
    cancel_button: 'Borrar todo',
    placeholder: 'Buscar',
    themes: 'Temas',
    activities: 'Actividades',
    default: 'Comenzar mi búsqueda',
    dates: 'Cualquier fecha',
    togglethemes: 'Ver temas',
    togglecalendar: 'Seleccionar un período',
  },
  timeRange: {
    morning: 'Por la mañana (de 8h a mediodía)',
    afternoon: 'Por la tarde (de mediodía a 17h)',
    evening: 'Por la noche (de 17h a medianoche)',
  },
  activities: {
    label: 'Lista de actividades',
    left: 'Mover a la izquierda',
    right: 'Mover a la derecha',
  },
  editor: {
    selection: {
      manual: 'Selección manual',
      auto: 'Selección automática',
      validate: 'Validar mi selección',
      configure: 'Configurar la selección',
      summary: 'Resumen de la selección',
      from_any_provider: 'de cualquier proveedor',
    },
    searchEngine: {
      title: 'Widget YouBOOK Motor de búsqueda',
    },
    title: 'Widget YouBOOK Destacados',
    create_widget: 'Crear el widget',
    delete_all: 'Borrar todo',
    add_product: 'Añadir una actividad',
    search_product: 'Buscar un producto ...',
    do_manual_selection: 'Realizar su selección manual',
    show_results: 'Mostrar resultados',
  },
  filters: {
    places: 'Lugar | Lugares',
    types: 'Tipo | Tipos',
    themes: 'Tema | Temas',
    audiences: 'Público | Públicos',
    internals: 'Interno | Internos',
  },
  providers: {
    regiondo: 'Regiondo',
    welogin: 'WeLogin',
    guidap: 'Guidap',
    bokun: 'Bókun',
  },
  aria: {
    details: 'Detalles de la oferta',
    presentation: 'presentación de la actividad',
    cta: 'reservar ahora esta actividad',
    cta_action: 'reservar una fecha',
    provider_logo: 'logo del proveedor',
    highlights: 'puntos fuertes de la actividad',
    provider_book: 'reserva con el proveedor',
    crosselling: 'otras actividades recomendadas',
  },
  cta: {
    share: 'Compartir',
    price: 'A partir de',
    book: 'Reservar',
    book_a_date: 'Reservar una fecha',
    add_to_favorites: 'Añadir a favoritos',
    retry: 'Intentar de nuevo',
    next_session: 'Próxima disponibilidad',
  },
  popover: {
    share: 'Compartir esta actividad:',
    go_to: 'Cómo llegar ?',
  },
  content: {
    reviews: 'Reseñas',
    recommended_by: 'Recomendado por',
    available_soon: 'Actividad pronto disponible',
    available_today: 'Disponible hoy',
    available_tomorrow: 'Disponible desde mañana',
    highlights: 'Puntos fuertes',
    options: 'Elija sus fechas, sus opciones ...',
    fee: 'Sin comisiones, mismo precio que directo',
    experience: 'Su experiencia',
    included: 'Incluido',
    not_included: 'No Incluido',
    powered_by: 'Impulsado por ',
    conditions: 'Condiciones',
    essentials: 'Esenciales',
    groups: 'Participantes',
    other: 'Adicionales',
    meeting_point: 'Punto de encuentro',
    go_to: 'Cómo llegar',
    address: 'Direccion :',
    how_to_go: 'Cómo llegar :',
    transport: 'Transporte :',
    book_peacefully: 'Reservar con tranquilidad con nuestro socio',
    complementary_infos: 'Información complementaria',
    locality: 'Localidad',
    other_activities: 'También le gustará',
    eco_friendly: {
      title: 'Se comprometen',
      description: 'Al elegir la actividad de baja emisión de carbono \« {activityName} \», está limitando considerablemente su impacto ambiental.',
      detail: 'Una actividad de baja emisión de carbono no emite o emite muy poco CO2 proveniente de energías fósiles.',
    },
    more: 'Ver más',
    less: 'Ver menos',
  },
  cart: {
    disclaimer: 'Reserve con tranquilidad a través de nuestro socio técnico.',
    article: '{count} artículo | {count} artículos',
  },
  error: {
    data_unavailable: 'La información sobre esta actividad no está disponible en este momento.',
  },
};
